import { useState } from 'react'
import useStates from './useStates'
// Antd
import { Avatar, Button, Popover } from 'antd'
import { CiLogin } from 'react-icons/ci'
import { TbUser } from 'react-icons/tb'
// general Context
import authService from 'authService'

const Header: React.FC = () => {
  const { section } = useStates()
  const [open, onSetOpen] = useState(false)

  const handleClick = val => {
    onSetOpen(val)
    !val && console.log(val)
  }

  return (
    <div className="portalHeader">
      <h1>{section}</h1>
      <Popover
        open={open}
        openClassName="p0"
        rootClassName="p0"
        onOpenChange={handleClick}
        arrow={false}
        trigger={'click'}
        content={
          <Button type="text" danger>
            <div
              className="centerItem"
              onClick={function () {
                authService.logout()
              }}
            >
              <CiLogin />
              <span style={{ marginLeft: '10px' }}>Salir</span>
            </div>
          </Button>
        }
      >
        <Button
          type="text"
          className="centerItem"
          style={{ padding: '0 15px', height: 40 }}
          onClick={e => {
            e.stopPropagation()
            onSetOpen(true)
          }}
        >
          <div className="centerItem">
            <Avatar
              icon={<TbUser />}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#1E99E1'
              }}
            />
            <p>{authService.state.name}</p>
          </div>
        </Button>
      </Popover>
    </div>
  )
}

export default Header
